var _circle, _path, _path2, _rect, _rect2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectionMustSellPerDay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#FFD8D8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1882 34.1134L29.9566 32.0607L29.4901 31.2832L29.0237 32.0607L27.792 34.1134L27.6483 34.4187C27.013 35.7687 27.9981 37.3209 29.4901 37.3209C30.9822 37.3209 31.9672 35.7687 31.3319 34.4187L31.1882 34.1134ZM29.4901 32.8381L28.4987 34.4905L28.3722 34.7593C27.9866 35.5788 28.5845 36.5209 29.4901 36.5209C30.3958 36.5209 30.9937 35.5788 30.6081 34.7593L30.4815 34.4905L29.4901 32.8381Z",
    fill: "#D91F05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.208 18.5H36.3212C37.1496 18.5 37.8212 19.1716 37.8212 20V41.6509H20.708V20C20.708 19.1716 21.3796 18.5 22.208 18.5Z",
    stroke: "#D91F05"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.7266,
    y: 22.123,
    width: 11.0755,
    height: 5.03774,
    rx: 1,
    stroke: "#D91F05"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    y: 41.4434,
    width: 19.5283,
    height: 3.83019,
    rx: 1.91509,
    stroke: "#D91F05"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4997 31.9902H44.5469C43.7185 31.9902 43.0469 31.3186 43.0469 30.4902L43.0469 26.0154L44.3967 24.2156L50.4997 30.8734V31.9902Z",
    stroke: "#D91F05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 36.1131H40.5472C41.6518 36.1131 42.5472 37.0086 42.5472 38.1131V39.7358C42.5472 42.07 44.4395 43.9622 46.7737 43.9622V43.9622V43.9622C48.7744 43.9622 50.3963 42.3403 50.3963 40.3395V31.8867",
    stroke: "#D91F05"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1314 26.0353L39.6158 23.4972C39.1163 23.1365 39.0037 22.4392 39.3644 21.9397C39.725 21.4402 40.4223 21.3276 40.9218 21.6882L44.4374 24.2264L43.1314 26.0353Z",
    stroke: "#D91F05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectionMustSellPerDay);
export default __webpack_public_path__ + "static/media/projection_must_sell_per_day.2e75bcd6cd264e7edc231940a74ecd38.svg";
export { ForwardRef as ReactComponent };